import Vue from "vue";
import Router from "vue-router";

import { authGuard } from "../auth";

Vue.use(Router);

/**
 * Modify the push method of vue-router
 */
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("../views/Home"),
      beforeEnter: authGuard,
    },
    {
      path: "/profile",
      name: "Profile",
      component: () => import("../views/Profile.vue"),
      beforeEnter: authGuard,
    },
    {
      path: "/alerts",
      name: "Alerts",
      component: () => import("../views/Alerts"),
      beforeEnter: authGuard,
    },
    {
      path: "/devices",
      name: "Devices",
      component: () => import("../views/DeviceHome"),
      beforeEnter: authGuard,
    },
    {
      path: "/device/:deviceId",
      name: "Device",
      component: () => import("../views/Device"),
      beforeEnter: authGuard,
    },
    {
      path: "/locations",
      name: "Locations",
      component: () => import("../views/LocationList"),
      beforeEnter: authGuard,
    },
    {
      path: "/location/:locationId",
      name: "Location",
      component: () => import("../views/Location"),
      beforeEnter: authGuard,
    },
    {
      path: "/poi_snapshot/:locationId",
      name: "POISnapshot",
      component: () => import("../views/Snapshot"),
      beforeEnter: authGuard,
    },
    {
      path: "/poi",
      name: "POIReport",
      component: () => import("../views/PoiReport"),
      beforeEnter: authGuard,
    },
    {
      path: "/journeys",
      name: "Journeys",
      component: () => import("../views/Journeys"),
      beforeEnter: authGuard,
    },
    {
      path: "/journey/:originId/:destinationId/:week",
      name: "Journey",
      component: () => import("../views/Journey"),
      beforeEnter: authGuard,
    },
    {
      path: "/report",
      name: "Report",
      component: () => import("../views/Reports"),
      beforeEnter: authGuard,
    },
    {
      path: "/report_fleet",
      name: "report_fleet",
      component: () => import("../views/Reports"),
      beforeEnter: authGuard,
    },
    {
      path: "/report_kpi",
      name: "report_kpi",
      component: () => import("../views/Reports"),
      beforeEnter: authGuard,
    },
    {
      path: "/assets",
      name: "Assets",
      component: () => import("../views/Assets"),
      beforeEnter: authGuard,
    },
    {
      path: "/asset/:deviceId",
      name: "asset",
      component: () => import("../views/Asset"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_analytics",
      name: "Analytics",
      component: () => import("../views/Analytics"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_ev",
      name: "EV_Modelling",
      component: () => import("../views/EVModelling"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_report",
      name: "Powercoil_Report",
      component: () => import("../views/PowerdataReports"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_alerts",
      name: "Powercoil_Alerts",
      component: () => import("../views/PowerdataAlerts"),
      beforeEnter: authGuard,
    },
    {
      path: "/checkcoverage",
      name: "Device_Test",
      component: () => import("../views/DeviceCoverage"),
    },
    {
      path: "/coverage_checker",
      name: "Device_Coverage",
      component: () => import("../views/CoverageChecker"),
      beforeEnter: authGuard,
    },
    {
      path: "/asset_snapshot/:deviceId",
      name: "Asset_Snapshot",
      component: () => import("../views/AssetSnapshotView"),
      beforeEnter: authGuard,
    },
    {
      path: "/powercoil_report_snapshot",
      name: "Report_Snapshot",
      component: () => import("../views/PowerdataReports"),
      beforeEnter: authGuard,
    },
    {
      path: "/error",
      name: "Error",
      component: () => import("../views/Error"),
      beforeEnter: authGuard,
    },
    {
      path: "/accessdenied",
      name: "AccessDenied",
      component: () => import("../views/AccessDenied"),
    },
  ],
});

export default router;
